import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import Slider from "react-slick";
import { ProdImg1, no_image_product_details } from "../../constant";

function NutrientsProSlider(props) {
  const ImageUrlRedux = useSelector((state) => state.AuthReducer.urlData);
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const slider1 = useRef(null);
  const slider2 = useRef(null);

  useEffect(() => {
    setNav1(slider1.current);
    setNav2(slider2.current);
  }, []);

  const ParamData = [
    {
      id: 1,
      img: ProdImg1,
    },
    {
      id: 2,
      img: ProdImg1,
    },
    {
      id: 3,
      img: ProdImg1,
    },
  ];

  return (
    <>
      <div className="product-slide">
        {props?.props?.images[0] ? (
          <>
            <Slider asNavFor={nav2} ref={slider1} arrows={false}>
              {props?.props?.images?.map((item, index) => {
                return (
                  <div
                    className="product-images mainimage-container"
                    key={index}
                  >
                    <figure className="big_images_nutrients_slider_figure">
                      <img
                        src={`${ImageUrlRedux?.product_image_url}/${item}`}
                        alt=""
                        className="img-fluid big_images_nutrients_slider"
                      />
                    </figure>
                  </div>
                );
              })}
            </Slider>
            <Slider
              asNavFor={nav1}
              ref={slider2}
              slidesToShow={
                props?.props?.images?.length > 0 ||
                props?.props?.images?.length < 3
                  ? props?.props?.images?.length
                  : 3
              }
              swipeToSlide={true}
              focusOnSelect={true}
              arrows={false}
              className="slick-custom"
            >
              {props?.props?.images?.map((item, index) => {
                return (
                  <div className="inner-image-container" key={index}>
                    <figure className="small_images_nutrients_slider_figure">
                      <img
                        src={`${ImageUrlRedux?.product_image_url}/${item}`}
                        alt=""
                        className="image-fluid image-width small_images_nutrients_slider"
                      />
                    </figure>
                  </div>
                );
              })}
            </Slider>
          </>
        ) : (
          <img
            className="no_image_avatar_product_details"
            src={`${
              props?.props?.thumbnail
                ? `${ImageUrlRedux?.product_thumbnail_url}/${props?.props?.thumbnail}`
                : no_image_product_details
            }`}
          />
        )}
      </div>
    </>
  );
}

export default NutrientsProSlider;
